export const meetingsConstants = {
    errors: {
        fetchFailed: "Failed to load meetings.",
        detailFailed: "Failed to load meeting.",
        createFailed: "Failed to create meeting.",
        updateFailed: "Failed to update meeting.",
        deleteFailed: "Failed to delete meeting.",
        voteFailed: "Failed to vote.",
        finalizeFailed: "Failed to finalize meeting.",
        rsvpFailed: "Failed to update RSVP.",
        commentFailed: "Failed to post comment.",
        attachmentFailed: "Failed to upload attachment.",
        genericError: "Something went wrong.",
    },
    messages: {
        createSuccess: "Meeting created.",
        updateSuccess: "Meeting updated.",
        deleteSuccess: "Meeting deleted.",
        finalizeSuccess: "Meeting finalized.",
        rsvpSuccess: "RSVP updated.",
        commentSuccess: "Comment added.",
        attachmentSuccess: "Attachment uploaded.",
    },
};
